// test2677
(2677 && 0);
